export const setHeaders = (data, aclData, internal = true) => {
  let arr = [];

  data &&
    data?.map((val, i) => {
      if (val?.acl) {
        if (aclData?.includes(val?.acl))
          arr.push({
            title: val?.title,
            key: val?.key,
          });
      } else {
        if (internal || val.external) {
          arr.push({
            title: val?.title,
            key: val?.key,
          });
        }
      }
    });
  return arr;
};
